export default __webpack_public_path__ + "static/media/pi.2f011539.jpeg";